// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__VaZV_","title":"styles_title__QKtlt","image":"styles_image__AxFPy","description":"styles_description__1mH_0"};